import React from 'react';
import { StatusIcon } from './StatusIcon';

interface Machine {
  enabled: boolean;
  [key: string]: any;
}

interface MachineListProps {
  machines: Record<string, Machine> | undefined;
  showStatusIcon?: boolean;
  emptyMessage?: string;
  className?: string;
}

// Machine name mapping for better display names
const MACHINE_NAME_MAPPING: Record<string, string> = {
  'M500': 'M-500',
  'P625': 'P-625',
  'P600Z': 'P-600Z',
  'IWM': 'IWM',
  'Manual': 'Manual',
  'competitorMachine': 'Competitor Machine',
  // Add more mappings as needed
};

const getDisplayName = (machineName: string): string => {
  return MACHINE_NAME_MAPPING[machineName] || machineName;
};

export const MachineList: React.FC<MachineListProps> = ({
  machines,
  showStatusIcon = false,
  emptyMessage = "No machines configured",
  className = ""
}) => {
  if (!machines || Object.keys(machines).length === 0) {
    return  null //<span className="text-gray-500 text-sm">{emptyMessage}</span>;
  }
  
  return (
    <div className={`flex flex-wrap gap-2 ${className}`}>
      {Object.entries(machines).map(([name, machine]: [string, Machine]) => (
        <div 
          key={name} 
          className={`px-2 py-1 rounded text-sm flex items-center gap-1 ${
            machine.enabled ? 'text-blueprint-blue bg-[rgba(0,39,63,0.06)]' : 'bg-gray-50 text-gray-500'
          }`}
        >
          {showStatusIcon && <StatusIcon enabled={machine.enabled} size="sm" />}
          {getDisplayName(name)}
        </div>
      ))}
    </div>
  );
}; 